import { createSelector } from 'reselect';

export const mapSection = state => state.map;

export const selectedResidentSelector = createSelector(
  mapSection,
  state => state.selectedResident
);
